import React from "react";

import classnames from "classnames";

import { Table as TableWithStyleProps } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("BEMTable");
type Props = {
  borders?: "none" | "horizontal" | "vertical" | "all" | "footer";
  condensed?: boolean;
  hover?: boolean;
  striped?: boolean;
  reverseStriped?: boolean;
  compact?: boolean;
  className?: string;

  /**
  @ignore
  * */
  children?: React.ReactNode;
  /**
  @ignore
  * */
};

const Table = ({ className, borders, condensed, hover, striped, reverseStriped, compact, ...other }: Props) => {
  let classes = classnames("table", bem(), className, {
    "table-condensed": condensed,
    [bem(null, "hover")]: hover,
    [bem(null, "striped")]: striped,
    [bem(null, "reverseStriped")]: reverseStriped,
    [bem(null, "compact")]: compact,
    "table-bordered": borders === "all",
  });

  if (borders) {
    // flow doesn't like coercing undefined to string
    classes += ` ${bem(null, `borders-${borders}`)}`;
  }

  // This default mb={4} is really annoying. We need to remove it.
  return <TableWithStyleProps mb={4} {...other} className={classes} />;
};

export { Table };
